import { createContext, useContext } from "react";

export type ProductTourContextValue = {
  replayAppHomeTour: () => void;
};

export const ProductTourContext = createContext<ProductTourContextValue | null>(null);

export function useProductTour(): ProductTourContextValue | null {
  return useContext(ProductTourContext);
}
